module.exports = "/images/mo.svg?0f0e087e1d3b8346d41a999966742535";